import { createFileRoute } from '@tanstack/react-router'
import { InterviewReportPage } from '@/features/interviews/components/interview-report-page'

export const Route = createFileRoute(
  '/_app/_auth/dashboard/_layout/interviews/$interviewId',
)({
  component: InterviewReportPage,
  beforeLoad: () => ({
    title: 'Interview Report',
    headerTitleKey: 'header.interviews.title',
    headerDescriptionKey: 'header.interviews.description',
  }),
})
